// extracted by mini-css-extract-plugin
export default {"item":"itemNews_item__nuR7-","itemText":"itemNews_itemText__BaBTN","popoverContent":"itemNews_popoverContent__CxE9Y","title":"itemNews_title__4iuQH"};